import {
	ConnectwiseCredentailsTestResponse,
	SyncroCredentailsTestResponse,
	AddSyncroIntegrationRequest,
	ConnectwiseTaxImport,
	ImportTaxRequest,
	AutotaskMapping,
	AutotaskTaxImportRequest,
	AutotaskConnectFormValues,
	InfusionSoftMetadataResponse,
	InfusionSoftMetadataRequest,
	KaseyaCredentialsTestRequest,
	AddWestcoastIntegrationRequest,
	RepairShoprCredentialsTestRequest,
	RepairShoprCredentailsTestResponse,
	AddRepairShoprIntegrationRequest,
	HubspotMetadataResponse,
	AddHubspotIntegrationRequest,
	StripeUser,
	QuickbooksMetadataResponse,
	AddQuickbooksIntegrationRequest,
	SupplierResponse,
	Supplier,
	SupplierCreateRequest,
	SupplierUpdateRequest,
	SupplierRequest,
	CustomDistributorFileDetailsRequest,
	CustomDistributorFileDetailsResponse,
	BulkActionResponse,
	AmazonMetadataResponse
} from "@/Contracts/Settings/index";
import axios, { AxiosResponse } from "axios";

import {
	getRequest,
	putRequest,
	postRequest,
	deleteRequest
} from "@/Utils/Service/BackendService";

import {
	IntegrationsResponse,
	AddEmailIntegrationRequest,
	AutotaskIntegrationResponse,
	AddConnectWiseIntegrationRequest,
	ConnenctwiseIntegrationCountResponse,
	DeleteZapierIntegrationRequest,
	AddKaseyaIntegrationRequest,
	AddIngramIntegrationRequest,
	AddTechDataIntegrationRequest,
	AddDAndHIntegrationRequest,
	AddSynnexIntegrationRequest,
	ConnectwiseCredentialsTestRequest,
	SyncroCredentialsTestRequest,
	AddCBIntegrationRequest
} from "@/Contracts/Settings";
import { UserCompany } from "@/Contracts/Users";
import {
	CustomDistributorUpdateRequest,
	CustomDistributorAuthDetailsResponse,
	MetaDataRequest,
	MetaDataResponse,
	ListPagePostRequest,
	ConnectionTypeServerKey,
	BulkUpdateRecordsRequest,
	BulkDeleteRecordsRequest,
	BulkExportRecordsRequest,
	FetchMetaDataRequest,
	IntegrationPageDetailsUpdateRequest
} from "@/Contracts";
import { RcFile } from "antd/lib/upload";

const getCompanyIntegrationsUrl = "/v2/companies/{company_id}/integrations";

const deleteCompanyIntegrationUrl = "/v2/companies/{company_id}/integrations";
// const addCompanyIntegrationUrl = '/v2/companies/{company_id}/integrations';

const deleteConnectWiseIntegrationUrl =
	"/v2/companies/integrations/connectwise/delete";
const addConnectWiseIntegrationUrl = "/v2/companies/integrations/connectwise";
const getConnectwiseIntegrationCountURL =
	"/v2/companies/integrations/connnectwise/entity/count";

const deleteEmailIntegrationUrl = "/v2/emails/delete";
const addEmailIntegrationUrl = "/v2/emails/connect?state={state}&code={code}";

const deleteAutotaskIntegrationUrl =
	"/v2/companies/integrations/autotask/delete";
const addAutotaskIntegrationUrl = "/v2/companies/integrations/autotask";

const deleteKaseyaIntegrationUrl = "/v2/companies/integrations/kaseya/delete";
const addKaseyaIntegrationUrl = "/v2/companies/integrations/kaseya";

const deleteIngramIntegrationUrl = "/v2/companies/integrations/ingram/delete";
const addIngramIntegrationUrl = "/v2/companies/integrations/ingram";

const deleteTechDataIntegrationUrl =
	"/v2/companies/integrations/techdata/delete";
const addTechDataIntegrationUrl = "/v2/companies/integrations/techdata";

const deleteDAndHIntegrationUrl = "/v2/companies/integrations/dandh/delete";
const addDAndHIntegrationUrl = "/v2/companies/integrations/dandh";

const deleteSynnexIntegrationUrl = "/v2/companies/integrations/synnex/delete";
const addSynnexIntegrationUrl = "/v2/companies/integrations/synnex";

const deleteCBIntegrationUrl =
	"/v2/companies/integrations/connect-booster/delete";
const addCBIntegrationUrl = "/v2/companies/integrations/connect-booster";

const resetPasswordUrl = "/v2/users/password/reset/email";

const testAutotaskCredentialsURL =
	"/v2/companies/integrations/autotask/metadata";
const testConnectwiseCredentialsURL =
	"/v2/companies/integrations/connectwise/test";
const testKaseyaCredentialsURL = "/v2/companies/integrations/kaseya/test";

const addSyncroIntegrationURL = "/v2/companies/integrations/syncro";
const deleteSyncroIntegrationURL = "/v2/companies/integrations/syncro/delete";

const testSyncroCredentialsURL = "/v2/companies/integrations/syncro/test";
const importConnectwiseTaxesURL =
	"/v2/companies/integrations/connectwise/tax/import";

const importAutotaskTaxesURL = "/v2/companies/integrations/autotask/import_tax";
const infusionSoftURL = "/v2/companies/integrations/infusionsoft/metadata";
const deleteInfusionSoftIntegrationURL =
	"/v2/companies/integrations/infusionsoft/delete";

const getAutotaskStageMappingURL =
	"/v2/companies/integrations/autotask/stage_mapping?selected_pipeline_id={pipeline_id}";

const deleteWestcoastIntegrationUrl =
	"/v2/companies/integrations/westcoast/delete";
const addWestcoastIntegrationUrl = "/v2/companies/integrations/westcoast";

const testRepairShoprCredentialsURL =
	"/v2/companies/integrations/repairshopr/test";
const deleteRepairShoprIntegrationURL =
	"/v2/companies/integrations/repairshopr/delete";
const addRepairShoprIntegrationURL = "/v2/companies/integrations/repairshopr";
const addStripeConnectionURL = "/v2/companies/integrations/stripe/onboard/";
const getStripeUserDetailsURL = "/v2/companies/integrations/stripe/get_user/";
const deletestripeUserURL = "/v2/companies/integrations/stripe/delete/";

const addPaymentsConnectionURL = "/v2/companies/integrations/payments/onboard/";
const deletePaymentsConnectionURL =
	"/v2/companies/integrations/payments/delete/";

const hubspotMetadataURL = "/v2/companies/integrations/hubspot/metadata/";
const deleteHubspotIntegrationURL =
	"/v2/companies/integrations/hubspot/delete/";
const addHubspotIntegrationURL = "/v2/companies/integrations/hubspot/";
const quickbooksMetadataURL = "/v2/companies/integrations/quickbooks/metadata/";
const deleteQuickbooksIntegrationURL =
	"/v2/companies/integrations/quickbooks/delete/";
const addQuickbooksIntegrationURL = "/v2/companies/integrations/quickbooks/";
const getSupplierViewURL = "/v2/supplier/view";
const getSuppliersURL = "/v2/supplier";
const getSupplierDetailsURL = "/v2/supplier/{id}";
const createSupplierURL = "/v2/supplier";
const updateSupplierURL = "/v2/supplier/{id}";
const deleteSupplierURL = "/v2/supplier/{id}";

const getCustomDistributorMetaDataURL =
	"/v2/companies/integrations/custom_distributor/metadata?connection_type={connection_type}&custom_distributor_id={custom_distributor_id}&custom_distributor_name={custom_distributor_name}";

const getFTPAuthDetailsURL =
	"/v2/companies/integrations/custom_distributor/auth?custom_distributor_id={custom_distributor_id}";

const CustomDistributorCreateURL =
	"/v2/companies/integrations/custom_distributor/";
const CustomDistributorDeleteURL =
	"/v2/companies/integrations/custom_distributor/delete";
const GenerateCustomDistributorIdURL =
	"v2/companies/integrations/custom_distributor/generateId";
const fetchCustomDistributorUploadedFileUrl = `/v2/companies/integrations/custom_distributor/fetch_file/{custom_distributor_id}`;

const CustomDistributorProcessFileURL =
	"/v2/companies/integrations/custom_distributor/process?custom_distributor_id={customDistributorId}&connection_type={connectionType}";

const fetchCustomDistributorFileDetailsURL =
	"/v2/companies/integrations/custom_distributor/fetch_file_details/{customDistributorId}";

const bulkActionURL = "/v2/async/operation";
const companyUpdateRequestURL = "/v2/companies";

const fetchCustomDistributorMetaDataURL =
	"/v2/companies/integrations/custom_distributor/fetch/metadata/{custom_distributor_id}";

const deleteAmazonIntegrationUrl = "/v2/companies/integrations/amazon/delete";
const amazonMetadataURL = "/v2/companies/integrations/amazon/metadata/";

export const getCompanyIntegrations = async (
	companyId: string
): Promise<IntegrationsResponse> => {
	try {
		const response: AxiosResponse<IntegrationsResponse> = await axios(
			getRequest(
				getCompanyIntegrationsUrl.replace("{company_id}", companyId),
				null,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteCompanyEmailIntegration = async (): Promise<void> => {
	try {
		const response: AxiosResponse<void> = await axios(
			putRequest(deleteEmailIntegrationUrl, {}, true, false, false)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const addCompanyEmailIntegration = async (
	addEmailIntegrationRequest: AddEmailIntegrationRequest
): Promise<IntegrationsResponse> => {
	try {
		const response: AxiosResponse<IntegrationsResponse> = await axios(
			putRequest(
				addEmailIntegrationUrl
					.replace("{state}", addEmailIntegrationRequest.state)
					.replace("{code}", addEmailIntegrationRequest.code),
				addEmailIntegrationRequest,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteCompanyConnectWiseIntegration =
	async (): Promise<IntegrationsResponse> => {
		try {
			const response: AxiosResponse<IntegrationsResponse> = await axios(
				putRequest(
					deleteConnectWiseIntegrationUrl,
					{},
					true,
					false,
					false
				)
			);
			return response.data;
		} catch (error) {
			return Promise.reject(error);
		}
	};

export const addCompanyConnectWiseIntegration = async (
	addConnectWiseIntegrationRequest: AddConnectWiseIntegrationRequest
): Promise<IntegrationsResponse> => {
	try {
		const response: AxiosResponse<IntegrationsResponse> = await axios(
			putRequest(
				addConnectWiseIntegrationUrl,
				addConnectWiseIntegrationRequest,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getConnectwiseIntegrationCount = async (
	getConnectwiseIntegrationCountRequest: AddConnectWiseIntegrationRequest
): Promise<ConnenctwiseIntegrationCountResponse> => {
	try {
		const response: AxiosResponse<ConnenctwiseIntegrationCountResponse> =
			await axios(
				putRequest(
					getConnectwiseIntegrationCountURL,
					getConnectwiseIntegrationCountRequest,
					true,
					false,
					false
				)
			);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteCompanyKaseyaIntegration =
	async (): Promise<IntegrationsResponse> => {
		try {
			const response: AxiosResponse<IntegrationsResponse> = await axios(
				putRequest(deleteKaseyaIntegrationUrl, {}, true, false, false)
			);
			return response.data;
		} catch (error) {
			return Promise.reject(error);
		}
	};

export const addCompanyKaseyaIntegration = async (
	addKaseyaIntegrationRequest: AddKaseyaIntegrationRequest
): Promise<IntegrationsResponse> => {
	try {
		const response: AxiosResponse<IntegrationsResponse> = await axios(
			putRequest(
				addKaseyaIntegrationUrl,
				addKaseyaIntegrationRequest,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const addCompanyIngramIntegration = async (
	addIngramIntegrationRequest: AddIngramIntegrationRequest
): Promise<IntegrationsResponse> => {
	try {
		const response: AxiosResponse<IntegrationsResponse> = await axios(
			putRequest(
				addIngramIntegrationUrl,
				addIngramIntegrationRequest,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteCompanyIngramIntegration =
	async (): Promise<IntegrationsResponse> => {
		try {
			const response: AxiosResponse<IntegrationsResponse> = await axios(
				putRequest(deleteIngramIntegrationUrl, {}, true, false, false)
			);
			return response.data;
		} catch (error) {
			return Promise.reject(error);
		}
	};

export const addCompanyTechDataIntegration = async (
	addTechDataIntegrationRequest: AddTechDataIntegrationRequest
): Promise<IntegrationsResponse> => {
	try {
		const response: AxiosResponse<IntegrationsResponse> = await axios(
			putRequest(
				addTechDataIntegrationUrl,
				addTechDataIntegrationRequest,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteCompanyTechDataIntegration =
	async (): Promise<IntegrationsResponse> => {
		try {
			const response: AxiosResponse<IntegrationsResponse> = await axios(
				putRequest(deleteTechDataIntegrationUrl, {}, true, false, false)
			);
			return response.data;
		} catch (error) {
			return Promise.reject(error);
		}
	};

export const addDAndHIntegration = async (
	addDAndHIntegrationRequest: AddDAndHIntegrationRequest
): Promise<IntegrationsResponse> => {
	try {
		const response: AxiosResponse<IntegrationsResponse> = await axios(
			putRequest(
				addDAndHIntegrationUrl,
				addDAndHIntegrationRequest,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteDAndHIntegration =
	async (): Promise<IntegrationsResponse> => {
		try {
			const response: AxiosResponse<IntegrationsResponse> = await axios(
				putRequest(deleteDAndHIntegrationUrl, {}, true, false, false)
			);
			return response.data;
		} catch (error) {
			return Promise.reject(error);
		}
	};

export const addSynnexIntegration = async (
	addSynnexIntegrationRequest: AddSynnexIntegrationRequest
): Promise<IntegrationsResponse> => {
	try {
		const response: AxiosResponse<IntegrationsResponse> = await axios(
			putRequest(
				addSynnexIntegrationUrl,
				addSynnexIntegrationRequest,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteSynnexIntegration =
	async (): Promise<IntegrationsResponse> => {
		try {
			const response: AxiosResponse<IntegrationsResponse> = await axios(
				putRequest(deleteSynnexIntegrationUrl, {}, true, false, false)
			);
			return response.data;
		} catch (error) {
			return Promise.reject(error);
		}
	};

export const addCBIntegration = async (
	addCBIntegrationRequest: AddCBIntegrationRequest
): Promise<IntegrationsResponse> => {
	try {
		const response: AxiosResponse<IntegrationsResponse> = await axios(
			putRequest(
				addCBIntegrationUrl,
				addCBIntegrationRequest,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteCBIntegration = async (): Promise<IntegrationsResponse> => {
	try {
		const response: AxiosResponse<IntegrationsResponse> = await axios(
			putRequest(deleteCBIntegrationUrl, {}, true, false, false)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteCompanyAutotaskIntegration =
	async (): Promise<IntegrationsResponse> => {
		try {
			const response: AxiosResponse<IntegrationsResponse> = await axios(
				putRequest(deleteAutotaskIntegrationUrl, {}, true, false, false)
			);
			return response.data;
		} catch (error) {
			return Promise.reject(error);
		}
	};

export const addCompanyAutotaskIntegration = async (
	addAutotaskIntegrationRequest: AutotaskIntegrationResponse
): Promise<IntegrationsResponse> => {
	try {
		const response: AxiosResponse<IntegrationsResponse> = await axios(
			putRequest(
				addAutotaskIntegrationUrl,
				addAutotaskIntegrationRequest,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteCompanyZapierIntegration = async (
	userCompany: UserCompany,
	deleteZapierIntegrationRequest: DeleteZapierIntegrationRequest
): Promise<IntegrationsResponse> => {
	try {
		const response: AxiosResponse<IntegrationsResponse> = await axios(
			putRequest(
				deleteCompanyIntegrationUrl.replace(
					"{company_id}",
					userCompany.id
				),
				deleteZapierIntegrationRequest,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const resetPasswordEmail = async (): Promise<void> => {
	try {
		const response: AxiosResponse<void> = await axios(
			getRequest(resetPasswordUrl, null, true, false, false)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const testAutotaskCredentials = async (
	testAutotaskCredentialsTestRequest: AutotaskIntegrationResponse
): Promise<AutotaskIntegrationResponse> => {
	let credentialsTestRequest = {};
	if (testAutotaskCredentialsTestRequest) {
		credentialsTestRequest = testAutotaskCredentialsTestRequest;
	}
	try {
		const response: AxiosResponse<AutotaskIntegrationResponse> =
			await axios(
				putRequest(
					testAutotaskCredentialsURL,
					credentialsTestRequest,
					true,
					false,
					false
				)
			);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const testConnectwiseCredentials = async (
	connectwiseCredentialsTestRequest: ConnectwiseCredentialsTestRequest
): Promise<ConnectwiseCredentailsTestResponse> => {
	let credentialsTestRequest = {};
	if (connectwiseCredentialsTestRequest) {
		credentialsTestRequest = connectwiseCredentialsTestRequest;
	}
	try {
		const response: AxiosResponse<ConnectwiseCredentailsTestResponse> =
			await axios(
				putRequest(
					testConnectwiseCredentialsURL,
					credentialsTestRequest,
					true,
					false,
					false
				)
			);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const testSyncroCredentials = async (
	syncroCredentialsTestRequest: SyncroCredentialsTestRequest
): Promise<SyncroCredentailsTestResponse> => {
	let credentialsTestRequest = {};
	if (syncroCredentialsTestRequest) {
		credentialsTestRequest = syncroCredentialsTestRequest;
	}
	try {
		const response: AxiosResponse<SyncroCredentailsTestResponse> =
			await axios(
				putRequest(
					testSyncroCredentialsURL,
					credentialsTestRequest,
					true,
					false,
					false
				)
			);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const addSyncroIntegration = async (
	addSyncroIntegrationRequest: AddSyncroIntegrationRequest
): Promise<IntegrationsResponse> => {
	try {
		const response: AxiosResponse<IntegrationsResponse> = await axios(
			putRequest(
				addSyncroIntegrationURL,
				addSyncroIntegrationRequest,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteSyncroIntegration =
	async (): Promise<IntegrationsResponse> => {
		try {
			const response: AxiosResponse<IntegrationsResponse> = await axios(
				putRequest(deleteSyncroIntegrationURL, {}, true, false, false)
			);
			return response.data;
		} catch (error) {
			return Promise.reject(error);
		}
	};

export const importTaxForConnectwise = async (
	importTaxRequest: ImportTaxRequest
): Promise<ConnectwiseTaxImport> => {
	try {
		const response: AxiosResponse<ConnectwiseTaxImport> = await axios(
			postRequest(
				importConnectwiseTaxesURL,
				importTaxRequest,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};

export const importTaxForAutotask = async (
	autotaskTaxImportRequest: AutotaskTaxImportRequest
): Promise<AutotaskMapping> => {
	try {
		const response: AxiosResponse<AutotaskMapping> = await axios(
			putRequest(
				importAutotaskTaxesURL,
				autotaskTaxImportRequest,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};

export const getInfusionSoftMetadata =
	async (): Promise<InfusionSoftMetadataResponse> => {
		try {
			const response = await axios(
				getRequest(infusionSoftURL, null, true, false, false)
			);
			return response.data;
		} catch (error) {
			console.error(error);
			return Promise.reject(error);
		}
	};

export const updateInfusionSoftMetadata = async (
	data: InfusionSoftMetadataRequest
): Promise<IntegrationsResponse> => {
	try {
		const response = await axios(
			putRequest(infusionSoftURL, data, true, false, false)
		);
		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};

export const getAutotaskStageMapping = async (
	testAutotaskCredentialsTestRequest: AutotaskConnectFormValues,
	selectedPipelineId: string
): Promise<AutotaskMapping> => {
	try {
		const response: AxiosResponse<AutotaskMapping> = await axios(
			putRequest(
				getAutotaskStageMappingURL.replace(
					"{pipeline_id}",
					selectedPipelineId
				),
				testAutotaskCredentialsTestRequest,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteInfusionSoftIntegration =
	async (): Promise<IntegrationsResponse> => {
		try {
			const response: AxiosResponse<IntegrationsResponse> = await axios(
				putRequest(
					deleteInfusionSoftIntegrationURL,
					{},
					true,
					false,
					false
				)
			);
			return response.data;
		} catch (error) {
			console.error(error);
			return Promise.reject(error);
		}
	};

export const testKaseyaCredentials = async (
	kaseyaCredentialsTestRequest: KaseyaCredentialsTestRequest
): Promise<any> => {
	try {
		let credentialsTestRequest = {};
		if (kaseyaCredentialsTestRequest) {
			credentialsTestRequest = kaseyaCredentialsTestRequest;
		}
		const response: AxiosResponse<any> = await axios(
			putRequest(
				testKaseyaCredentialsURL,
				credentialsTestRequest,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};

export const addWestcoastIntegration = async (
	addWestcoastIntegrationRequest: AddWestcoastIntegrationRequest
): Promise<IntegrationsResponse> => {
	try {
		const response: AxiosResponse<IntegrationsResponse> = await axios(
			putRequest(
				addWestcoastIntegrationUrl,
				addWestcoastIntegrationRequest,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteWestcoastIntegration =
	async (): Promise<IntegrationsResponse> => {
		try {
			const response: AxiosResponse<IntegrationsResponse> = await axios(
				putRequest(
					deleteWestcoastIntegrationUrl,
					{},
					true,
					false,
					false
				)
			);
			return response.data;
		} catch (error) {
			return Promise.reject(error);
		}
	};

export const testRepairShoprCredentials = async (
	repairShoprCredentialsTestRequest: RepairShoprCredentialsTestRequest
): Promise<RepairShoprCredentailsTestResponse> => {
	let credentialsTestRequest = {};
	if (repairShoprCredentialsTestRequest) {
		credentialsTestRequest = repairShoprCredentialsTestRequest;
	}
	try {
		const response: AxiosResponse<RepairShoprCredentailsTestResponse> =
			await axios(
				putRequest(
					testRepairShoprCredentialsURL,
					credentialsTestRequest,
					true,
					false,
					false
				)
			);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteRepairShoprIntegration =
	async (): Promise<IntegrationsResponse> => {
		try {
			const response: AxiosResponse<IntegrationsResponse> = await axios(
				putRequest(
					deleteRepairShoprIntegrationURL,
					{},
					true,
					false,
					false
				)
			);
			return response.data;
		} catch (error) {
			return Promise.reject(error);
		}
	};

export const addRepairShoprIntegration = async (
	addRepairShoprIntegrationRequest: AddRepairShoprIntegrationRequest
): Promise<IntegrationsResponse> => {
	try {
		const response: AxiosResponse<IntegrationsResponse> = await axios(
			putRequest(
				addRepairShoprIntegrationURL,
				addRepairShoprIntegrationRequest,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getHubspotMetadata =
	async (): Promise<HubspotMetadataResponse> => {
		try {
			const response = await axios(
				getRequest(hubspotMetadataURL, null, true, false, false)
			);
			return response.data;
		} catch (error) {
			console.error(error);
			return Promise.reject(error);
		}
	};
export const addStripeConnection = async (): Promise<string> => {
	try {
		const reponse: AxiosResponse<{ url: string }> = await axios(
			postRequest(addStripeConnectionURL, null, true, false, false)
		);
		return reponse.data.url;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};
export const addPaymentsConnection = async (): Promise<string> => {
	try {
		const reponse: AxiosResponse<{ url: string }> = await axios(
			postRequest(addPaymentsConnectionURL, null, true, false, false)
		);
		return reponse.data.url;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};
export const getQuickbooksMetadata =
	async (): Promise<QuickbooksMetadataResponse> => {
		try {
			const response = await axios(
				getRequest(quickbooksMetadataURL, null, true, false, false)
			);
			return response.data;
		} catch (error) {
			console.error(error);
			return Promise.reject(error);
		}
	};

export const deleteHubspotIntegration =
	async (): Promise<IntegrationsResponse> => {
		try {
			const response: AxiosResponse<IntegrationsResponse> = await axios(
				putRequest(deleteHubspotIntegrationURL, {}, true, false, false)
			);
			return response.data;
		} catch (error) {
			return Promise.reject(error);
		}
	};
export const getStripeUserDetails = async (): Promise<StripeUser> => {
	try {
		const reponse: AxiosResponse<StripeUser> = await axios(
			getRequest(getStripeUserDetailsURL, null, true, false, false)
		);
		return reponse.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteQuickbooksIntegration =
	async (): Promise<IntegrationsResponse> => {
		try {
			const response: AxiosResponse<IntegrationsResponse> = await axios(
				putRequest(
					deleteQuickbooksIntegrationURL,
					{},
					true,
					false,
					false
				)
			);
			return response.data;
		} catch (error) {
			return Promise.reject(error);
		}
	};

export const addHubspotIntegration = async (
	addHubspotIntegrationRequest: AddHubspotIntegrationRequest
): Promise<IntegrationsResponse> => {
	try {
		const response: AxiosResponse<IntegrationsResponse> = await axios(
			putRequest(
				addHubspotIntegrationURL,
				addHubspotIntegrationRequest,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};
export const deleteStripeUser = async (): Promise<UserCompany> => {
	try {
		const response: AxiosResponse<UserCompany> = await axios(
			deleteRequest(deletestripeUserURL, null, true, false)
		);
		return response.data;
	} catch (err) {
		return Promise.reject(err);
	}
};
export const deletePaymentsUser = async (): Promise<UserCompany> => {
	try {
		const response: AxiosResponse<UserCompany> = await axios(
			deleteRequest(deletePaymentsConnectionURL, null, true, false)
		);
		return response.data;
	} catch (err) {
		return Promise.reject(err);
	}
};
export const addQuickbooksIntegration = async (
	addQuickbooksIntegrationRequest: AddQuickbooksIntegrationRequest
): Promise<IntegrationsResponse> => {
	try {
		const response: AxiosResponse<IntegrationsResponse> = await axios(
			putRequest(
				addQuickbooksIntegrationURL,
				addQuickbooksIntegrationRequest,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getSupplier = async (
	searchQuery?: string,
	selectedSupplierId?: string
): Promise<SupplierResponse> => {
	try {
		const url = `${getSuppliersURL}`;
		let queryParams = "";

		if (searchQuery) {
			queryParams = `?q=${searchQuery}`;
		}

		if (selectedSupplierId) {
			queryParams = `${
				!!queryParams.length
					? `&selected_id=${selectedSupplierId}`
					: `?selected_id=${selectedSupplierId}`
			}`;
		}

		const response: AxiosResponse<SupplierResponse> = await axios(
			getRequest(url + queryParams, null, true, false, false)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getSupplierView = async (
	pagination?: ListPagePostRequest
): Promise<SupplierResponse> => {
	try {
		const response: AxiosResponse<SupplierResponse> = await axios(
			postRequest(getSupplierViewURL, pagination, true, false, false)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getSupplierDetails = async (
	supplierId: string
): Promise<Supplier> => {
	try {
		const response: AxiosResponse<Supplier> = await axios(
			getRequest(
				getSupplierDetailsURL.replace("{id}", supplierId),
				null,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const addSupplier = async (
	supplier: SupplierCreateRequest
): Promise<Supplier> => {
	try {
		const response: AxiosResponse<Supplier> = await axios(
			postRequest(createSupplierURL, supplier, true, false, false)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const updateSupplier = async (
	supplierId: string,
	supplier: SupplierUpdateRequest
): Promise<Supplier> => {
	try {
		const response: AxiosResponse<Supplier> = await axios(
			putRequest(
				updateSupplierURL.replace("{id}", supplierId),
				supplier,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteSupplier = async (supplierId: string) => {
	try {
		const response: AxiosResponse = await axios(
			deleteRequest(
				deleteSupplierURL.replace("{id}", supplierId),
				null,
				true,
				false
			)
		);

		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const searchSupplier = async (supplierRequest: SupplierRequest) => {
	try {
		let queryParams = supplierRequest.limit
			? `limit=${supplierRequest.limit}`
			: "";

		if (supplierRequest.keywords) {
			queryParams = `${queryParams}${!!queryParams.length ? "&" : ""}${
				!!supplierRequest.keywords?.length
					? `q=${supplierRequest.keywords}`
					: ""
			}`;
		}

		if (supplierRequest.selected_id) {
			queryParams = `${queryParams}${!!queryParams.length ? "&" : ""}${
				!!supplierRequest.selected_id?.length
					? `selected_id=${supplierRequest.selected_id}`
					: ""
			}`;
		}

		const url = `${getSuppliersURL}${
			!!queryParams.length ? `?${queryParams}` : ""
		}`;
		const response: AxiosResponse<SupplierResponse> = await axios(
			getRequest(url, null, true, false, false)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getCustomDistributorMetaData = async (
	metaDataRequest: MetaDataRequest
): Promise<MetaDataResponse> => {
	try {
		const formData = new FormData();
		metaDataRequest.url && formData.set("url", metaDataRequest.url);
		metaDataRequest.file && formData.set("file", metaDataRequest.file);

		const fileSeparatorParam = metaDataRequest.file_type
			? `&file_type=${metaDataRequest.file_type}&file_separator=${metaDataRequest.file_separator}`
			: "";

		const response = await axios(
			postRequest(
				getCustomDistributorMetaDataURL
					.replace(
						"{connection_type}",
						metaDataRequest.connection_type
					)
					.replace("{custom_distributor_id}", metaDataRequest.id)
					.replace(
						"{custom_distributor_name}",
						metaDataRequest.custom_distributor_name || ""
					) + fileSeparatorParam,
				formData,
				true,
				false,
				true
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const addCustomDistributor = async (
	customDistributorUpdateRequest: CustomDistributorUpdateRequest
): Promise<IntegrationsResponse> => {
	try {
		const response = await axios(
			putRequest(
				CustomDistributorCreateURL,
				customDistributorUpdateRequest,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const getCustomDistributorAuthDetails = async (
	distributorId: string
): Promise<CustomDistributorAuthDetailsResponse> => {
	try {
		const response = await axios(
			getRequest(
				getFTPAuthDetailsURL.replace(
					"{custom_distributor_id}",
					distributorId
				),
				null,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const deleteCustomDistributor = async (
	integrationId: string
): Promise<IntegrationsResponse> => {
	try {
		const response = await axios(
			putRequest(
				CustomDistributorDeleteURL,
				{ id: integrationId },
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const generateCustomDistributorId = async (): Promise<string> => {
	try {
		const response = await axios(
			getRequest(GenerateCustomDistributorIdURL, null, true, false, false)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};
export const processCustomDistributorFile = async (
	file: RcFile,
	distributorId: string,
	connectionType: ConnectionTypeServerKey
) => {
	try {
		const formData = new FormData();
		formData.set("file", file);
		const response = await axios(
			postRequest(
				CustomDistributorProcessFileURL.replace(
					"{customDistributorId}",
					distributorId
				).replace("{connectionType}", connectionType),
				formData,
				true,
				false,
				true
			)
		);
		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const fetchCustomDistributorUploadedfile = async (
	connectionType: ConnectionTypeServerKey,
	distributorId: string,
	data?: CustomDistributorFileDetailsRequest
): Promise<any> => {
	try {
		const payload: any = { connection_type: connectionType };
		if (
			data &&
			[
				ConnectionTypeServerKey.VIA_URL,
				ConnectionTypeServerKey.VIA_FTP,
				ConnectionTypeServerKey.VIA_SFTP,
				ConnectionTypeServerKey.VIA_SECURE_URL
			].includes(connectionType)
		) {
			payload.data = data;
		}
		const response = await axios(
			postRequest(
				fetchCustomDistributorUploadedFileUrl.replace(
					"{custom_distributor_id}",
					distributorId
				),
				payload,
				true,
				false,
				false
			)
		);
		return response;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const fetchCustomDistributorFileDetails = async (
	distributorId: string
): Promise<CustomDistributorFileDetailsResponse> => {
	try {
		const response = await axios(
			getRequest(
				fetchCustomDistributorFileDetailsURL.replace(
					"{customDistributorId}",
					distributorId
				),
				null,
				true,
				false,
				false
			)
		);

		return response.data;
	} catch (error) {
		return Promise.reject(error);
	}
};

export const bulkDeleteRecords = async (
	bulkDeleteRecordsRequest: BulkDeleteRecordsRequest
): Promise<BulkActionResponse> => {
	try {
		const response: AxiosResponse<any> = await axios(
			postRequest(
				bulkActionURL,
				bulkDeleteRecordsRequest,
				true,
				false,
				false
			)
		);

		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};

export const bulkUpdateRecords = async (
	bulkUpdateRecordsRequest: BulkUpdateRecordsRequest
): Promise<BulkActionResponse> => {
	try {
		const response: AxiosResponse<any> = await axios(
			postRequest(
				bulkActionURL,
				bulkUpdateRecordsRequest,
				true,
				false,
				false
			)
		);

		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};

export const bulkExportRecords = async (
	bulkExportRecordsRequest: BulkExportRecordsRequest
): Promise<BulkActionResponse> => {
	try {
		const response: AxiosResponse<BulkActionResponse> = await axios(
			postRequest(
				bulkActionURL,
				bulkExportRecordsRequest,
				true,
				false,
				false
			)
		);

		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};

export const fetchCustomDistributorMetaData = async (
	fetchCustomDistributorMetaDataRequest: FetchMetaDataRequest,
	distributorId: string
): Promise<MetaDataResponse> => {
	try {
		const response = await axios(
			postRequest(
				fetchCustomDistributorMetaDataURL.replace(
					"{custom_distributor_id}",
					distributorId
				),
				fetchCustomDistributorMetaDataRequest,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};

export const updateIntegrationPageDetails = async (
	integrationPageDetailsUpdateRequest: IntegrationPageDetailsUpdateRequest
): Promise<UserCompany> => {
	try {
		const response: AxiosResponse<any> = await axios(
			putRequest(
				companyUpdateRequestURL,
				integrationPageDetailsUpdateRequest,
				true,
				false,
				false
			)
		);
		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};

export const deleteAmazonIntegration =
	async (): Promise<IntegrationsResponse> => {
		try {
			const response: AxiosResponse<IntegrationsResponse> = await axios(
				putRequest(deleteAmazonIntegrationUrl, {}, true, false, false)
			);
			return response.data;
		} catch (error) {
			return Promise.reject(error);
		}
	};

export const getAmazonMetadata = async (): Promise<AmazonMetadataResponse> => {
	try {
		const response = await axios(
			getRequest(amazonMetadataURL, null, true, false, false)
		);
		return response.data;
	} catch (error) {
		console.error(error);
		return Promise.reject(error);
	}
};
